import { createApiActions, createApiActionTypes } from 'iqvia-shared';
import { submit } from 'redux-form';

import { getIntl, getLocale, getMessages, loadLocaleData } from '../../Shared/localization';
import {
  JOURNEY_BUILDER_FORM_NAME,
  JOURNEY_BUILDER_SETTINGS,
  REMAINING_BRANCH_KEY,
} from '../constants/JourneyBuilder';
import {
  normalizeFieldValues,
  normalizeObjectValue,
  unflat,
} from '../../Shared/Helpers/JourneyBuilderHelper';
import apiNameEnums from '../../Enums/apiNames';

export const types = {
  JOURNEY_BUILDER_CANNOT_MOVE_TO_OTHER_STEP: 'JOURNEY_BUILDER_CANNOT_MOVE_TO_OTHER_STEP',
  JOURNEY_BUILDER_CLOSE_ERROR_WINDOW: 'JOURNEY_BUILDER_CLOSE_ERROR_WINDOW',
  JOURNEY_BUILDER_DECISION_SPLIT_ERROR: 'JOURNEY_BUILDER_DECISION_SPLIT_ERROR',
  JOURNEY_BUILDER_DECISION_SPLIT_GET_OBJECTS: 'JOURNEY_BUILDER_DECISION_SPLIT_GET_OBJECTS',
  JOURNEY_BUILDER_DECISION_SPLIT_START: 'JOURNEY_BUILDER_DECISION_SPLIT_START',
  JOURNEY_BUILDER_UPDATE_DONE_BUTTON: 'JOURNEY_BUILDER_UPDATE_DONE_BUTTON',
  JOURNEY_BUILDER_PAYLOAD_ADD_PATH: 'JOURNEY_BUILDER_PAYLOAD_ADD_PATH',
  JOURNEY_BUILDER_PAYLOAD_FETCH_SUCCESS: 'JOURNEY_BUILDER_PAYLOAD_FETCH_SUCCESS',
  JOURNEY_BUILDER_PAYLOAD_REMOVE_PATH: 'JOURNEY_BUILDER_PAYLOAD_REMOVE_PATH',
  JOURNEY_BUILDER_PAYLOAD_RENAME_PATH: 'JOURNEY_BUILDER_PAYLOAD_RENAME_PATH',
  JOURNEY_BUILDER_PAYLOAD_SET_PATH_OBJECT: 'JOURNEY_BUILDER_PAYLOAD_SET_PATH_OBJECT',
  JOURNEY_BUILDER_PAYLOAD_SET_PATH_CONTACTTYPE: 'JOURNEY_BUILDER_PAYLOAD_SET_PATH_CONTACTTYPE',
  JOURNEY_BUILDER_PAYLOAD_SET_DYNAMIC_LIST_OBJECT_FIELD:
    'JOURNEY_BUILDER_PAYLOAD_SET_DYNAMIC_LIST_OBJECT_FIELD',
  JOURNEY_BUILDER_PAYLOAD_SET_PATH_OBJECT_FIELD: 'JOURNEY_BUILDER_PAYLOAD_SET_PATH_OBJECT_FIELD',
  JOURNEY_BUILDER_REQUESTING_NEW_STEP: 'JOURNEY_BUILDER_REQUESTING_NEW_STEP',
  JOURNEY_BUILDER_SET_TOKEN: 'JOURNEY_BUILDER_SET_TOKEN',
  JOURNEY_BUILDER_SAVE_JOURNEY_ID: 'JOURNEY_BUILDER_SAVE_JOURNEY_ID',
  JOURNEY_BUILDER_UPDATE_ACTIVITY: 'JOURNEY_BUILDER_UPDATE_ACTIVITY',
  SET_FORM_READONLY: 'SET_FORM_READONLY',
  TRANSLATE_OUTCOMES: 'TRANSLATE_OUTCOMES',
};

export const journeyBuilderGetMetadataActionTypes = createApiActionTypes(
  apiNameEnums.JOURNEY_BUILDER_JOURNEY_GET_METADATA
);

export const updateDoneButton = state => ({
  type: types.JOURNEY_BUILDER_UPDATE_DONE_BUTTON,
  payload: state,
});

export const addPath = () => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_ADD_PATH,
});

export const cannotMoveToOtherStep = () => ({
  type: types.JOURNEY_BUILDER_CANNOT_MOVE_TO_OTHER_STEP,
});

export const journeyBuilderDecisionSplitStart = () => ({
  type: types.JOURNEY_BUILDER_DECISION_SPLIT_START,
});

export const removePath = index => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_REMOVE_PATH,
  payload: { index },
});

export const renamePath = (index, newValue) => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_RENAME_PATH,
  payload: { index, newValue },
});

export const setPathObject = (index, newValue) => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_SET_PATH_OBJECT,
  payload: { index, newValue },
});

export const setPathContactType = (index, newValue) => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_SET_PATH_CONTACTTYPE,
  payload: { index, newValue },
});

export const setDependentPathObjectFields = (index, newValue) => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_SET_DYNAMIC_LIST_OBJECT_FIELD,
  payload: { index, newValue },
});

export const setPathObjectField = (index, fieldName, newValue) => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_SET_PATH_OBJECT_FIELD,
  payload: { index, fieldName, newValue },
});

export const updateActivity = payload => ({
  type: types.JOURNEY_BUILDER_UPDATE_ACTIVITY,
  payload,
});

export const closeErrorWindow = () => ({
  type: types.JOURNEY_BUILDER_CLOSE_ERROR_WINDOW,
});

export const fetchLocalization = locale =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_GET_LOCALIZATION, {
    url: JOURNEY_BUILDER_SETTINGS.localizationUrl.replace('{locale}', locale),
    actionTypeOverrides: {
      success: {
        payload: (action, state, response) =>
          response.json().then(jsonData => {
            window.App.localizationInfo = jsonData;
            loadLocaleData();

            return {
              locale: getLocale(),
              messages: getMessages(),
            };
          }),
      },
    },
  });

export const fetchDecisionSplitObjects = (locale, buID) =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_DECISION_SPLIT_GET_OBJECTS, {
    url: JOURNEY_BUILDER_SETTINGS.decisionSplitGetObjectsUrl
      .replace('{locale}', locale)
      .replace('{buID}', buID),
  });

export const fetchDecisionSplitObjectFields = (objectId, locale, buID) =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_DECISION_SPLIT_GET_OBJECT_FIELDS, {
    url: JOURNEY_BUILDER_SETTINGS.decisionSplitGetObjectFieldsUrl
      .replace('{objectId}', objectId)
      .replace('{locale}', locale)
      .replace('{buID}', buID),
  });

export const fetchDecisionSplitPathObjectFields = (objectId, pathObjectID, field, locale, buID) =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_DECISION_SPLIT_GET_DYNAMIC_LIST_OBJECT_FIELDS, {
    url: JOURNEY_BUILDER_SETTINGS.decisionSplitGetObjectFieldsUrl
      .replace('{objectId}', pathObjectID)
      .replace('{locale}', locale)
      .replace('{buID}', buID),
    actionTypeOverrides: {
      success: {
        payload: (_action, _state, response) =>
          response.json().then(payload => ({ payload, objectId, field })),
      },
    },
  });

export const fetchDecisionSplitUserData = (rootMID, token) =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_DECISION_SPLIT_GET_USER_DATA, {
    url: JOURNEY_BUILDER_SETTINGS.decisionSplitGetUserDataUrl
      .replace('{rootMID}', rootMID)
      .replace('{token}', token),
  });

export const fetchDecisionSplitLocalizedFields = (rootMID, callback) =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_DECISION_SPLIT_GET_LOCALIZED_FIELDS, {
    url: JOURNEY_BUILDER_SETTINGS.decisionSplitGetLocalizedFieldsUrl.replace('{rootMID}', rootMID),
    actionTypeOverrides: {
      success: {
        payload: (_a, _b, response) =>
          response.json().then(json => {
            callback(json);
          }),
      },
    },
  });

export const fetchBranches = data => {
  const field = 'field';
  const obj = unflat(data);
  const branches = Object.keys(obj)
    .filter(key => field in obj[key])
    .map(key => {
      const branch = obj[key][field];
      branch.branchKey = key;
      branch.branchName = obj[key].val;
      branch.contactType = obj[key]['contactType'];
      return branch;
    });

  branches.push({
    branchKey: REMAINING_BRANCH_KEY,
    branchName: data[REMAINING_BRANCH_KEY],
  });

  return branches;
};

export const submitDecisionSplitForm = (values, _, JourneyBuilderSettings) => dispatch => {
  const payload = JourneyBuilderSettings.payload;
  payload.name = JourneyBuilderSettings.JourneyBuilder.name;
  payload.metaData.isConfigured = true;
  const branches = fetchBranches(values);
  payload.arguments.execute.inArguments = [
    {
      dataModelVersion: '2',
      nodeName:
        JourneyBuilderSettings.JourneyBuilder.name ||
        getIntl().formatMessage({
          id: 'journeyBuilder.decisionSplit_oceDigitalDecision',
        }),
      journeyVersion: '{{Context.VersionNumber}}',
      branches,
      currentBusinessUnitMID: JourneyBuilderSettings.currentMID,
    },
  ];
  dispatch(updateActivity(payload));
};

export const fetchJourneyMetadata = (journeyId, buID) =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_JOURNEY_GET_METADATA, {
    url: JOURNEY_BUILDER_SETTINGS.journeyMetadata
      .replace('{journeyId}', journeyId)
      .replace('{buID}', buID),
  });

export const fetchIsHCOEnabled = buID =>
  createApiActions(apiNameEnums.JOURNEY_BUILDER_JOURNEY_GET_HCO_ENABLED, {
    url: JOURNEY_BUILDER_SETTINGS.getIsHCOEnabledUrl.replace('{buID}', buID),
  });

export const decisionSplitInteractionLoaded = interaction => dispatch => {
  if (!interaction.id) {
    // Journey id is null so the journey is not saved
    // Unsaved journey cannot have metadata
    dispatch({ type: journeyBuilderGetMetadataActionTypes.failure.type });
  } else {
    if (interaction.status !== 'DRAFT') {
      dispatch({ type: types.SET_FORM_READONLY });
    }
    dispatch({
      type: types.JOURNEY_BUILDER_SAVE_JOURNEY_ID,
      payload: { id: interaction.id },
    });
  }
};

export const fetchPayloadSuccess = data => ({
  type: types.JOURNEY_BUILDER_PAYLOAD_FETCH_SUCCESS,
  payload: { data },
});

export const initDecisionSplit = data => dispatch => {
  const execute = data.arguments.execute || {};
  const [inArgumentsDate] = execute.inArguments || [];

  const { dataModelVersion } = inArgumentsDate || {};
  const rootMID = window.App.rootBusinessUnitMID;
  if (!dataModelVersion && rootMID) {
    dispatch(
      fetchDecisionSplitLocalizedFields(rootMID, localizedData => {
        const { fields, objects } = localizedData;
        const modifiedOutcomes = data.outcomes.map(outcome => {
          const { fieldValues, objectValue } = outcome.metaData;
          if (fieldValues && objectValue) {
            const normalizedFieldValues = normalizeFieldValues(fieldValues, fields);
            const normalizedObjectValue = normalizeObjectValue(objectValue, objects);

            return {
              ...outcome,
              metaData: {
                ...outcome.metaData,
                fieldValues: normalizedFieldValues,
                objectValue: normalizedObjectValue,
              },
            };
          } else {
            return outcome;
          }
        });

        dispatch(fetchPayloadSuccess({ ...data, outcomes: modifiedOutcomes }));
      })
    );
  } else {
    dispatch(fetchPayloadSuccess(data));
  }
};

export const requestingNewStep = () => ({
  type: types.JOURNEY_BUILDER_REQUESTING_NEW_STEP,
});

export const requestsMovingToOtherStep = isLoading => dispatch => {
  if (!isLoading) {
    dispatch(requestingNewStep());
    dispatch(submit(JOURNEY_BUILDER_FORM_NAME));
  }
};

export const setToken = tokens => ({
  type: types.JOURNEY_BUILDER_SET_TOKEN,
  payload: { tokens },
});

export const translateOutcomes = () => ({
  type: types.TRANSLATE_OUTCOMES,
});



// WEBPACK FOOTER //
// ./src/JourneyBuilder/actions/JourneyBuilder.js